<button class="sidebar-minimizer" type="button" appSidebarMinimizer appBrandMinimizer (click)="toggleMenu()"></button>
